<template>
    <section v-if="state > -1">
        <ul class="gadget-step-progress mb-4">
            <li :class="{ 'active': state >= $Constants.JOB_STATUS_NEW }">เปิดใบงาน</li>
            <li :class="{ 'active': state >= $Constants.JOB_STATUS_PENDING }">ตรวจสอบ</li>
            <li :class="{ 'active': state === $Constants.JOB_STATUS_COMPLETE }">ออกบิล</li>
        </ul>
    </section>
</template>

<script>
export default {
    data() {
        return {
            state: -1
        }
    },
    props: {
        loadData: Object
    },
    mounted() {
        this.state = this.loadData ? this.loadData.status : this.$Constants.JOB_STATUS_NEW;
    }
}
</script>